import React,{useState,useEffect} from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import {Navigate} from "react-router-dom";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Webcam from "react-webcam";
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DesktopDatePicker} from '@mui/x-date-pickers/DesktopDatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import MenuConfiguraciones from './components/MenuConfiguracion';
import FavoriteIcon from '@mui/icons-material/Favorite';
import withAuth from './components/withAuth';
import {isAuthenticated} from './services/Auth';

const videoConstraints = {
  width: 1024,
  height: 768,
  facingMode: "user"
};

const Asistencias = () => {
  return(<div>AAA</div>);
};

/*
const Usuarios = () => {
  const camaraRef = React.createRef();
  const [baseUrl,setBaseUrl] = useState("");
  const [nuevoUsuario, setNuevoUsuario] = useState(false);
  const [tomarFoto, setTomarFoto] = useState(false);

  const [datos, setDatos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [tiposIdentificaciones, setTiposIdentificaciones] = useState([]);
  const [perfiles, setPerfiles] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [sexos, setSexos] = useState([]);
  
  const [empresa, setEmpresa] = useState(null);
  const [sucursal, setSucursal] = useState(null);
  const [tipoIdentificacion, setTipoIdentificacion] = useState(null);
  const [identificacion, setIdentificacion] = useState("");
  const [nombres, setNombres] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [correo, setCorreo] = useState("");
  const [clave, setClave] = useState("");
  const [perfil, setPerfil] = useState(null);
  const [cargo, setCargo] = useState(null);
  const [sexo, setSexo] = useState(null);
  const [fechaNacimiento, setFechaNacimiento] = useState(null);
  const [foto, setFoto] = useState("data:image/png;base64,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");

  useEffect(() => { 
    setBaseUrl(process.env.REACT_APP_BASE_URL);
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Control-Allow-Origin': '*'
      }
    };
    
    fetch(baseUrl+'/api/v1/usuario/obtener/todo', requestOptions)
    .then(response => response.json())
    .then((data) => {
      setDatos(data);
    });

    fetch(baseUrl+'/api/v1/asistencia/obtener/todo', requestOptions)
    .then(response => response.json())
    .then((data) => {
      setDatos(data);
    });

    fetch(baseUrl+'/api/v1/tipo/identificacion/obtener/todo', requestOptions)
    .then(response => response.json())
    .then((data) => {
      setTiposIdentificaciones(data);
    });

    fetch(baseUrl+'/api/v1/perfil/obtener/todo', requestOptions)
    .then(response => response.json())
    .then((data) => {
      setPerfiles(data);
    });

    fetch(baseUrl+'/api/v1/cargo/obtener/todo', requestOptions)
    .then(response => response.json())
    .then((data) => {
      setCargos(data);
    });

    fetch(baseUrl+'/api/v1/sexo/obtener/todo', requestOptions)
    .then(response => response.json())
    .then((data) => {
      setSexos(data);
    });
  },[baseUrl]);

  const EncabezadoTabla = () => {
    return(
      <>
        <Button color="primary" variant='contained' onClick={AbrirNuevoUsuario}>Nuevo</Button>
      </>
    );
  };

  const BorrarDatos = () => {
    setEmpresa(null);
    setSucursal(null);
    setTipoIdentificacion(null);
    setIdentificacion("");
    setNombres("");
    setApellidos("");
    setCorreo("");
    setClave("");
    setPerfil(null);
    setCargo(null);
    setSexo(null);
    setFechaNacimiento(null);
    setFoto("data:image/png;base64,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");
  };

  const AbrirNuevoUsuario = (e) => {
    e.preventDefault();
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Control-Allow-Origin': '*'
      }
    };
    fetch(baseUrl+'/api/v1/empresa/obtener/todo', requestOptions)
    .then(response => response.json())
    .then((data) => {
      setEmpresas(data);
    });
    setNuevoUsuario(true);
  }

  const CambioEmpresa = (event,data) => {
    event.preventDefault();
    const id_empresa = data.id;
    setEmpresa(data);

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Control-Allow-Origin': '*'
      }
    };
    fetch(`${baseUrl}/api/v1/sucursal/empresa/obtener/${id_empresa}`, requestOptions)
    .then(response => response.json())
    .then((data) => {
      setSucursales(data);
    });
  };

  const CambioSucursal = (event,data) => {
    event.preventDefault();
    setSucursal(data);
  };

  const CambioTipoIdentificacion = (event,data) => {
    event.preventDefault();
    setTipoIdentificacion(data);
  };

  const CambioPerfil = (event,data) => {
    event.preventDefault();
    setPerfil(data);
  };

  const CambioCargo = (event,data) => {
    event.preventDefault();
    setCargo(data);
  };

  const CambioSexo = (event,data) => {
    event.preventDefault();
    setSexo(data);
  };

  const CambioIdentificacion = (event) => {
    event.preventDefault();
    const {value} = event.target;
    const id_tipo_identificacion = tipoIdentificacion.id;
    const identificacion = value;

    const data = {
      "id_tipo_identificacion": id_tipo_identificacion,
      "identificacion": identificacion
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Control-Allow-Origin': '*'
      },
      body: JSON.stringify(data)
    };
    fetch(`${baseUrl}/api/v1/usuario/identificacion/existe`, requestOptions)
    .then(response => response.json())
    .then((data) => {
      console.log(data);
      //setSucursales(data);
    });
    setIdentificacion(value);
  };

  const CambioNombres = (event) => {
    event.preventDefault();
    const {value} = event.target;
    setNombres(value.toUpperCase());
  };

  const CambioApellidos = (event) => {
    event.preventDefault();
    const {value} = event.target;
    setApellidos(value.toUpperCase());
  };

  const CambioCorreo = (event) => {
    event.preventDefault();
    const {value} = event.target;
    setCorreo(value);
  };

  const CambioClave = (event) => {
    event.preventDefault();
    const {value} = event.target;
    setClave(value);
  };

  const CambioFechaNacimiento = (newValue) => {
    setFechaNacimiento(newValue);
  };

  const CerrarNuevoUsuario = (e) => {
    e.preventDefault();
    setNuevoUsuario(false);
  };

  const CerrarTomarFoto = (e) => {
    e.preventDefault();
    setTomarFoto(false);
  };

  const RegistrarNuevoUsuario = (e) => {
    e.preventDefault();
    const id_empresa = empresa.id;
    const id_sucursal = sucursal.id;
    const id_tipo_identificacion = tipoIdentificacion.id;
    const id_cargo = cargo.id;
    const id_sexo = sexo.id;
    const id_perfil = perfil.id;

    const data = {
      "id_empresa": id_empresa,
      "id_sucursal": id_sucursal,
      "id_tipo_identificacion": id_tipo_identificacion,
      "id_cargo": id_cargo,
      "id_sexo": id_sexo,
      "id_perfil": id_perfil,
      "nombres": nombres,
      "apellidos": apellidos,
      "correo": correo,
      "clave": clave,
      "identificacion": identificacion,
      "fecha_nacimiento": moment(fechaNacimiento).format("YYYY-MM-DD"),
      "base64_foto": foto,
      "habilitado": true,
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Control-Allow-Origin': '*'
      },
      body: JSON.stringify(data)
    };

    fetch(`${baseUrl}/api/v1/usuario/agregar`, requestOptions)
    .then(response => response.json())
    .then((data) => {
      if(data.id_usuario > 0){
        BorrarDatos();
        alert("usuario agregado correctamente!");
      }
    });
    
  };

  const RegistrarNuevaFoto = (e) => {
    e.preventDefault();
    const imagen = camaraRef.current.getScreenshot();
    setFoto(imagen);
    setTomarFoto(false);
  };

  const columnas = [
    {
      name: 'ID',
      selector: row => row.id,
    },
    {
      name: 'Nombres',
      selector: row => row.nombres,
    },
    {
      name: 'Apellidos',
      selector: row => row.apellidos,
    },
    {
      name: 'Correo',
      selector: row => row.correo,
    },
    {
      name: 'Fecha Creado',
      selector: row => row.fecha_creado,
    },
    {
      name: 'Fecha Modificado',
      selector: row => row.fecha_modificado,
    },
  ];

  const ValidarFormulario = () => {
    if(
      empresa !== null &&
      sucursal !== null &&
      tipoIdentificacion !== null &&
      identificacion.length > 0 &&
      perfil !== null &&
      cargo !== null &&
      sexo !== null &&
      fechaNacimiento !== null && 
      nombres.length > 0 &&
      apellidos.length > 0 &&
      correo.length > 0 &&
      clave.length > 0
    ){
      return true;
    }else{
      return false;
    }
  };

  return(
    <>
      <DataTable title="Usuarios" columns={columnas} data={datos} pagination subHeader subHeaderComponent={<EncabezadoTabla/>} persistTableHead/>
      <Dialog fullScreen open={nuevoUsuario} onClose={CerrarNuevoUsuario} aria-labelledby="nuevo-usuario" aria-describedby="nuevo-usuario-description">
        <DialogTitle id="nuevo-usuario">
          {"CREAR NUEVO USUARIO"}
        </DialogTitle>
        <DialogContent>
          <Box sx={{flexGrow:1, mt:1}}>
            <Grid container spacing={2}>
              <Grid item xs={10}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField label="Nombres" variant="outlined" onChange={CambioNombres} value={nombres} />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField label="Apellidos" variant="outlined" onChange={CambioApellidos} value={apellidos} />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <Autocomplete disablePortal value={empresa} onChange={CambioEmpresa} options={empresas} getOptionLabel={(option) => `${option.nombre}`} renderInput={(params) => <TextField {...params} label="Empresa" />}/>
                  </Grid>
                  <Grid item xs={3}>
                    <Autocomplete disablePortal value={sucursal} onChange={CambioSucursal} options={sucursales} getOptionLabel={(option) => `${option.nombre}`} renderInput={(params) => <TextField {...params} label="Sucursal" />}/>
                  </Grid>
                  <Grid item xs={3}>
                    <Autocomplete disablePortal value={tipoIdentificacion} onChange={CambioTipoIdentificacion} options={tiposIdentificaciones} getOptionLabel={(option) => `${option.nombre}`} renderInput={(params) => <TextField {...params} label="Tipo Identificación" />}/>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField label="Identificación" variant="outlined" onChange={CambioIdentificacion} value={identificacion} disabled={(!tipoIdentificacion) ? true: false}/>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <Autocomplete disablePortal value={perfil} onChange={CambioPerfil} options={perfiles} getOptionLabel={(option) => `${option.nombre}`} renderInput={(params) => <TextField {...params} label="Perfil" />}/>
                  </Grid>
                  <Grid item xs={3}>
                    <Autocomplete disablePortal value={cargo} onChange={CambioCargo} options={cargos} getOptionLabel={(option) => `${option.nombre}`} renderInput={(params) => <TextField {...params} label="Cargo" />}/>
                  </Grid>
                  <Grid item xs={3}>
                    <Autocomplete disablePortal value={sexo} onChange={CambioSexo} options={sexos} getOptionLabel={(option) => `${option.nombre}`} renderInput={(params) => <TextField {...params} label="Sexo" />}/>
                  </Grid>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker label="Fecha Nacimiento" inputFormat="dd/MM/yyyy" value={fechaNacimiento} onChange={CambioFechaNacimiento} renderInput={(params) => <TextField {...params} />}/>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField label="Correo" variant="outlined" onChange={CambioCorreo} value={correo} />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField type="password" label="Clave" variant="outlined" onChange={CambioClave} value={clave} />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2}>
                <Paper variant="outlined">
                  <img src={foto} width="204.8" height="153.6"/>
                  <Button variant="contained" onClick={() => setTomarFoto(true) } fullWidth>
                    TOMAR FOTO
                  </Button>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={CerrarNuevoUsuario}>Cerrar</Button>
          <Button onClick={RegistrarNuevoUsuario} disabled={(ValidarFormulario() === true) ? false: true}>Agregar</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={tomarFoto} onClose={CerrarTomarFoto} aria-labelledby="tomar-foto" aria-describedby="tomar-foto-description">
        <DialogTitle id="nuevo-usuario">
          {"TOMAR FOTO"}
        </DialogTitle>
        <DialogContent>
          <Webcam ref={camaraRef} audio={false} width={409.6} height={307.2} screenshotFormat="image/jpeg" screenshotQuality={1} videoConstraints={videoConstraints}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={CerrarTomarFoto}>Cerrar</Button>
          <Button onClick={RegistrarNuevaFoto}>Tomar Foto</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
*/

const Configuracion = () => {
  const [value, setValue] = useState(0);

  if (isAuthenticated() === false) return <Navigate to="/iniciar/sesion" />;

  return (
    <div className="container">
      <MenuConfiguraciones/>
      {/*
      <Box sx={{width:"100%",mt:5.5}}>
        <BottomNavigation showLabels value={value} onChange={(event, newValue) => {setValue(newValue);}}>
          <BottomNavigationAction label="Usuarios" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Empresas" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Sucursales" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Asistencias" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Perfiles" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Sexos" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Turnos" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Identificaciones" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Cargos" icon={<FavoriteIcon />} />
        </BottomNavigation>
      */}
    </div>
  );
};

export default withAuth(Configuracion);